import PinDiamondIcon from "./icons/Diamond_Selected.png"
import PinEmeraldIcon from "./icons/Emerald_Selected.png"
import PinIboIcon from "./icons/IBO_Selected.png"
import PinPlatinumIcon from "./icons/Platinum_Selected.png"

import StatusPublishedIcon from "./icons/Published_Icon.svg"
import StatusUnpublishedIcon from "./icons/Unpublished_Icon.svg"

import AppDigitalIcon from "./icons/Digital_Info_App_Icon.svg"
import AppInfoCenterIcon from "./icons/Info_Center_App_Icon.svg"
import AppRetailIcon from "./icons/Retail_App_Icon.svg"
import AppSSFIcon from "./icons/Simple_Selling_Framework_Icon.svg"
import AppMembershipIcon from "./icons/Membership_Icon.svg"

import classNames from "classnames"

import styles from "./index.module.css";

export function ContentSummary({ item}) {
    const {
      status,
      pinLevelPermission,
      applications
    } = item;

    const pinMap = {
        diamond: 8,
        emerald: 4,
        platinum: 2,
        ibo: 1,
    };

    const publishedStatus = {
        published: 1
    }

    const application = {
        retail: 1,
        digital: 2,
        ssf: 3,
        infoCenter: 4,
        membership: 5
    }

    return (
      <>
        <div className={classNames(styles.container)}>
            {status === publishedStatus.published && (
                <img src={StatusPublishedIcon} alt="Status: Published"/>
            )}

            {status !== publishedStatus.published && (
                <img src={StatusUnpublishedIcon} alt="Status: Unpublished"/>
            )}
            <span>&nbsp;&nbsp;</span>

            <img src={PinIboIcon} className={classNames({[styles.opaque] : (pinLevelPermission & pinMap.ibo == pinMap.ibo), [styles.seeThrough] : (pinLevelPermission & pinMap.ibo) != pinMap.ibo})} alt="PinLevel: IBO"/>
            <img src={PinPlatinumIcon} className={classNames({[styles.opaque] : (pinLevelPermission & pinMap.platinum) == pinMap.platinum, [styles.seeThrough] : (pinLevelPermission & pinMap.platinum) != pinMap.platinum})} alt="PinLevel: Platinum"/>
            <img src={PinEmeraldIcon} className={classNames({[styles.opaque] : (pinLevelPermission & pinMap.emerald) == pinMap.emerald, [styles.seeThrough] : (pinLevelPermission & pinMap.emerald) != pinMap.emerald})} alt="PinLevel: Emerald"/>
            <img src={PinDiamondIcon} className={classNames({[styles.opaque] : (pinLevelPermission & pinMap.diamond) == pinMap.diamond, [styles.seeThrough] : (pinLevelPermission & pinMap.diamond) != pinMap.diamond})} alt="PinLevel: Diamond"/>

            <div className={classNames(styles.divider)}></div>

            {applications.includes(application.retail) && (
                <img src={AppRetailIcon} alt="App: Retail"/>
            )}
            {applications.includes(application.ssf) && (
                <img src={AppSSFIcon} alt="App: Simple Selling Framework"/>
            )}
            {applications.includes(application.digital) && (
                <img src={AppDigitalIcon} alt="App: Digital"/>
            )}
            {applications.includes(application.infoCenter) && (
                <img src={AppInfoCenterIcon} alt="App: Info Center"/>
            )}
            {applications.includes(application.membership) && (
                <img src={AppMembershipIcon} alt="App: Membership"/>
            )}
        </div>
      </>
    );
  }
  
  ContentSummary.propTypes = {};
  